import { DomainSheet } from "@/components/domain";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { CalendarView } from ".";
import { ReservationDetail } from "../$id.index";

export const Route = createFileRoute(
  "/(reservations)/reservations/calendar/$id/",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const navigate = useNavigate();
  return (
    <>
      <CalendarView />
      <DomainSheet
        noOutlet
        onClose={() => {
          navigate({ to: "/reservations/calendar" });
        }}
      >
        <ReservationDetail
          id={id}
          onDeleteSuccess={() => {
            navigate({ to: "/reservations/calendar" });
          }}
          editLinkProps={{
            to: "/reservations/calendar/$id/edit",
            params: { id },
          }}
        />
      </DomainSheet>
    </>
  );
}
